import * as React from "react";
import { SVGProps, memo } from "react";
const SvgSpacesMediumExtract = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="spaces-medium-extract_svg__Layer_1"
    x={0}
    y={0}
    width={24}
    height={24}
    xmlSpace="preserve"
    role="img"
    {...props}
  >
    <style>{".spaces-medium-extract_svg__st0{fill:#666766}"}</style>
    <path
      className="spaces-medium-extract_svg__st0"
      d="M8 16c-2.6 0-4-.9-4-1.3V7c.9.6 2.3 1 4 1V7c-2.4 0-4-.9-4-1.5S5.6 4 8 4c1.8 0 3.1.5 3.7 1h1.2c-.4-1.2-2.4-2-4.9-2-2.8 0-5 1.1-5 2.5v9.2C3 16 5.2 17 8 17v-1z"
    />
    <path
      className="spaces-medium-extract_svg__st0"
      d="M19 8.5C19 7.1 16.8 6 14 6S9 7.1 9 8.5V13h1v-3c.9.6 2.3 1 4 1 1.7 0 3.1-.4 4-1v7.7c0 .4-1.4 1.3-4 1.3s-4-.9-4-1.3V16H9v1.7C9 19 11.2 20 14 20s5-1 5-2.3V8.5zM14 10c-2.4 0-4-.9-4-1.5S11.6 7 14 7s4 .9 4 1.5-1.6 1.5-4 1.5z"
    />
    <path
      id="spaces-medium-extract_svg__Arrow_6_"
      className="spaces-medium-extract_svg__st0"
      d="m13.5 14.4-2.2-1.8s-.2-.1-.2.1V14h-1c-1.4 0-2-.6-2-2v-1H7v1c0 2 1 3 3 3h1v1.4c0 .1.1.1.2.1l2.2-1.8c.2-.1.2-.2.1-.3z"
    />
  </svg>
);
const Memo = memo(SvgSpacesMediumExtract);
export default Memo;
